const columns = [
  {
    id: "situacao",
    label: "Situação",
    width: 10,
    minWidth: 10,
  },
  {
    id: "tipo",
    label: "",
    width: 10,
    minWidth: 10,
  },
  {
    id: "statusIntegracao",
    label: "",
    width: 30,
    minWidth: 30,
  },
  {
    id: "identificadorPrimario",
    label: "",
    width: 30,
    minWidth: 30,
  },
  {
    id: "identificadorSecundario",
    label: "",
    width: 30,
    minWidth: 30,
  },
  {
    id: "nomeCliente",
    label: "Nome",
    width: 200,
    minWidth: 20,
  },
  {
    id: "dataAgendamento",
    label: "Agendado",
    width: 5,
    minWidth: 5,
  },
  {
    id: "Data",
    label: "Data",
    align: "center",
    width: 30,
    minWidth: 30,
  },
  {
    id: "valor",
    label: "Valor",
    align: "right",
    width: 30,
    minWidth: 30,
  },
  {
    id: "opcao",
    label: "Opções",
    align: "center",
    width: 80,
    minWidth: 30,
  },
];

export default columns;
